import Footer10 from './Footer10'
export default Footer10
